import { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItemOption,
  MenuOptionGroup,
  Tooltip,
} from '@vimeo/bokeh';
import { ChevronDownSmall } from '@vimeo/bokeh-icons';

import { T } from '../../translations';
import { Sort } from '../../types';

interface SortCommentsProps {
  defaultSort: string;
  isPublic: boolean;
  setSort: (sort: Sort) => void;
  onSortSelect: (sort: Sort) => void;
}

export const SortComments = ({
  defaultSort,
  isPublic,
  setSort,
  onSortSelect,
}: SortCommentsProps) => {
  const [sortValue, setSortValue] = useState<string>(defaultSort);

  let sortOptions: Sort[] = [
    {
      value: 'newest',
      label: T.Newest,
      type: 'date',
      direction: 'desc',
    },
    {
      value: 'oldest',
      label: T.Oldest,
      type: 'date',
      direction: 'asc',
    },
  ];

  const privateSortOption: Sort[] = [
    {
      value: 'timecode',
      label: T.TimeCode,
      type: 'time_code',
      direction: 'asc',
    },
  ];

  if (!isPublic) {
    sortOptions = [...sortOptions, ...privateSortOption];
  }

  const sortComments = (sort: Sort) => {
    setSortValue(sort.label);
    const newSort = {
      value: sort.value,
      label: sort.label,
      type: sort.type,
      direction: sort.direction,
    };
    setSort(newSort);
    onSortSelect?.(newSort);
  };

  useEffect(() => {
    setSort({
      value: 'newest',
      label: T.Newest,
      type: 'date',
      direction: 'desc',
    });
    setSortValue(T.Newest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPublic]);

  return (
    <Box>
      <Menu placement="bottom">
        <Tooltip label={T.Sort} placement="top">
          <MenuButton
            onFocus={(e) => e.preventDefault()}
            as={Button}
            variant="minimal"
            size="sm"
            rightIcon={<ChevronDownSmall />}
          >
            {sortValue}
          </MenuButton>
        </Tooltip>
        <MenuList background="background">
          <MenuOptionGroup
            defaultValue={sortValue}
            value={sortValue}
            title={T.SortBy}
            textColor="text-secondary"
          >
            {sortOptions.map((option) => (
              <MenuItemOption
                key={option.label}
                value={option.label}
                onClick={() => sortComments(option)}
              >
                {option.label}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Box>
  );
};
